import React from 'react';
import RegisterComponent from '../../components/RegisterComponent/RegisterComponent';

const Register = () => {
    return (
        <div className="register-container">
            <img src="/cb_logo.png" alt="ClientBloom Logo" className="layout-register-logo" />
            <RegisterComponent />
        </div>
    );
};

export default Register;
